import React, { CSSProperties } from 'react';
import ModalComponent from './ModalComponent';

interface Props {
  children?: React.ReactNode,
  className?: string,
  disableTouchEvents?: boolean,
  isOpen: boolean,
  large?: boolean,
  onAfterClose?: () => any,
  onAfterOpen?: () => any,
  onRequestClose: (arg: any) => any,
  overlayClassName?: string,
  style?: {
    overlay?: CSSProperties,
    content?: CSSProperties,
  },
}

export default function ModalContainer(props: Props) {
  const {
    className,
    children,
    disableTouchEvents,
    isOpen,
    large,
    onAfterClose,
    onAfterOpen,
    onRequestClose,
    overlayClassName,
    style,
  } = props;
  return (
    <ModalComponent
      className={className}
      disableTouchEvents={disableTouchEvents}
      isOpen={isOpen}
      onAfterClose={onAfterClose}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      large={large}
      overlayClassName={overlayClassName}
      style={style}
    >
      {children}
    </ModalComponent>
  );
}

ModalContainer.displayName = 'ModalContainer';
